import i18n from '../i18n';

const MONDAY_ANCHOR = new Date(2024, 0, 1);

/** BCP-47 tags for Intl (short codes like hy/ka need region on some browsers). */
const INTL_LOCALE_MAP = {
  hy: 'hy-AM',
  ka: 'ka-GE',
  kk: 'kk-KZ',
  uz: 'uz-UZ',
  az: 'az-AZ',
};

function localeTag() {
  const code = i18n.language || 'ru';
  return INTL_LOCALE_MAP[code] || code;
}

function weekDayFromI18n(dayId, format) {
  const short = i18n.t(`scheduleManager:days.${dayId}`, { defaultValue: '' });
  if (short && !short.startsWith('scheduleManager:')) return short;
  if (format === 'long') {
    const long = i18n.t(`scheduleManager:daysLong.${dayId}`, { defaultValue: '' });
    if (long && !long.startsWith('scheduleManager:')) return long;
  }
  return '';
}

function weekDayLabels(format) {
  return Array.from({ length: 7 }, (_, i) => {
    const d = new Date(MONDAY_ANCHOR);
    d.setDate(MONDAY_ANCHOR.getDate() + i);
    return d
      .toLocaleDateString(localeTag(), { weekday: format })
      .replace(/\.$/u, '');
  });
}

export function getShortWeekDays() {
  return weekDayLabels('short');
}

export function getLongWeekDays() {
  return weekDayLabels('long');
}

export function getMinWeekDays() {
  return weekDayLabels('narrow');
}

export function getWeekDayLabel(dayOfWeek, format = 'short') {
  const id = Number(dayOfWeek);
  if (id < 1 || id > 7) return '';
  const fromBundle = weekDayFromI18n(id, format);
  if (fromBundle) return fromBundle;
  const idx = id - 1;
  const list = format === 'long' ? getLongWeekDays() : getShortWeekDays();
  return list[idx] ?? '';
}

export { formatMonth, formatDate, formatShortDate, formatWeekdayDate } from './dateFormat';
